import { useInfiniteQuery } from '@tanstack/react-query'
import notificationService from '../../service'
import {
  type NotificationInfiniteFilter,
  notificationQueryKeys,
} from '../keys/notification.query-keys'

const DEFAULT_PAGE_SIZE = 20

export const useNotificationInfiniteList = (
  filter: Omit<NotificationInfiniteFilter, 'pageSize'> & { pageSize?: number }
) => {
  const pageSize = filter.pageSize ?? DEFAULT_PAGE_SIZE
  return useInfiniteQuery({
    queryKey: notificationQueryKeys.infiniteList({ ...filter, pageSize }),
    queryFn: ({ pageParam }) =>
      notificationService.getList({ ...filter, pageSize, cursor: pageParam }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.object?.nextCursor ?? undefined,
    retry: (failureCount, error: unknown) => {
      // 403 không thử lại tự động
      if (typeof error === 'object' && error !== null && 'status' in error) {
        if ((error as { status?: number }).status === 403) return false
      }
      return failureCount < 2
    },
  })
}
